export default {
  'investment.title': 'Strategic Investment Portfolio',
  'investment.subtitle': 'We actively invest in and acquire high-potential technology companies to accelerate innovation and create value across the technology ecosystem.',
  'investment.description': 'Our investment strategy focuses on identifying and nurturing companies that align with our vision of transforming the financial technology landscape.',
  
  'investment.features': [
    'Startup Funding & Acceleration',
    'M&A Advisory Services',
    'Portfolio Management',
    'Growth Strategy Development'
  ],
  
  'investment.fintech.title': 'Fintech Startups',
  'investment.fintech.description': 'High-potential financial technology companies revolutionizing digital payments, lending, and financial services.',
  'investment.fintech.portfolio': '8 Companies',
  'investment.fintech.growth': '+45%',
  
  'investment.realEstate.title': 'Real Estate Tech',
  'investment.realEstate.description': 'Strategic holdings in property technology and real estate development projects with strong growth potential.',
  'investment.realEstate.portfolio': '5 Projects',
  'investment.realEstate.growth': '+32%',
  
  'investment.agribusiness.title': 'Agribusiness',
  'investment.agribusiness.description': 'Diversified investments in agricultural technology and sustainable farming solutions for food security.',
  'investment.agribusiness.portfolio': '3 Ventures',
  'investment.agribusiness.growth': '+28%',
  
  'investment.portfolio': 'Portfolio',
  'investment.growth': 'Growth',
};
